var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalTemplate',{ref:"ModalRefInform",attrs:{"title":"Información","type":"informativo","message":"Conexión inestable, falló el registro de la actuación","showIcon":true,"loadingSaveButton":_vm.loadingSaveButtonInModalTemplate,"severity":"danger","closable":false},on:{"confirm":function($event){return _vm.redirectToHome()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }